( function ( _s ) {
	/** Add class to body once the page is ready */
	_s( document ).ready( () => {
		_s( 'body' ).addClass( 'ready' );
	} );

	// Observe body height changes
	const resizeObserver = new ResizeObserver( () => {
		_s( window ).trigger( 'fr:body-height-changed' );
	} );

	resizeObserver.observe( document.body );

	/** Check if keyup event key is ENTER */

	window.isEventKeyEnter = e => {
		return (
			( e.type === 'keyup' || e.type === 'keydown' || e.type === 'keypress' ) &&
			( e.key === 'Enter' || e.code === 'Enter' || e.code === 'NumpadEnter' )
		);
	};

	/** Check if keyup event key is Space bar */

	window.isEventKeySpaceBar = e => {
		return (
			( e.type === 'keyup' || e.type === 'keydown' || e.type === 'keypress' ) &&
			( e.key === ' ' || e.code === 'Space' )
		);
	};

	/** Body click */
	_s( 'body' ).on( 'click', e => {
		_s( window ).trigger( 'fr:body-click', e );
	} );
} )( window._s );
